import { gql } from '@apollo/client';
import {
  ALL_VERIFICATION_PROFILE_FIELDS,
  RELEVANT_TELNYX_VERIFY_PROFILE_FIELDS,
  RELEVANT_TWILIO_VERIFICATION_SERVICE_FIELDS,
} from '../fragments/verificationProfiles';

export const fetchVerificationProfilesQuery = gql`
  ${ALL_VERIFICATION_PROFILE_FIELDS}
  query FetchVerificationProfiles {
    verificationProfiles {
      ...AllVerificationProfileFields
    }
  }
`;

export const fetchTelnyxVerifyProfilesQuery = gql`
  ${RELEVANT_TELNYX_VERIFY_PROFILE_FIELDS}
  query FetchTelnyxVerifyProfiles($espAccountId: Long!) {
    telnyxVerifyProfiles(espAccountId: $espAccountId) {
      ...RelevantTelnyxVerifyProfileFields
    }
  }
`;

export const fetchTwilioVerificationServicesQuery = gql`
  ${RELEVANT_TWILIO_VERIFICATION_SERVICE_FIELDS}
  query FetchTwilioVerificationServices($espAccountId: Long!) {
    twilioVerificationServices(espAccountId: $espAccountId) {
      ...RelevantTwilioVerificationServiceFields
    }
  }
`;
